import { UserOptionsEnum } from '@appTypes/common.types';
import { environment } from '@env/environment';

export const PAGES_REGISTRY = [
  { label: 'Tours', breadcrumbLabel: 'Search tours', path: './tours' },
  { label: 'Hotels', breadcrumbLabel: 'Search hotels', path: './hotels' },
  { label: 'Flights', breadcrumbLabel: 'Search flights', path: './avia' },
  { label: 'Excursions', breadcrumbLabel: 'Search excursions', path: './excursions' },
  { label: 'Cruises', breadcrumbLabel: 'Search cruises', path: './cruises' },
  { label: 'Accounts', path: './accounts', hidePageBackground: true },
  { label: 'Checkout', path: './checkout', hidePageBackground: true },
  { label: 'Reservations List', path: './reservations' },
  { label: 'Change Password', breadcrumbLabel: 'Change Password', path: './change-password', hidePageBackground: true },
  /* ... */
  { label: 'Kazunion tour', path: environment.desktopDefaultPagePath },
  { label: 'Main', path: environment.desktopDefaultPagePath }
];
/** A header tab; `testId` = its stable test hook (C16) where one exists, else the index-based `header-menu-link-<n>`. */
export interface HeaderMenuItem {
  label: string;
  icon?: string;
  path: string;
  testId?: string;
}

export const HEADER_MENU: HeaderMenuItem[] = [
  { label: 'Tours', icon: 'tours-icon', path: './tours' },
  { label: 'Hotels', icon: 'hotels-icon', path: './hotels' },
  { label: 'Flights', icon: 'avia-icon', path: './avia' },
  { label: 'Excursions', icon: 'excursions-icon', path: './excursions' },
  /** Cruises phase 4 (R-47): shown only when the agency's market is on sale (header filter) */
  { label: 'Cruises', icon: 'cruises-icon', path: './cruises', testId: 'web-tab-cruises' },
  ...(environment.disableReservations ? [] : [{ label: 'Reservations List', path: './reservations' }])
];

export const USER_OPTIONS_MENU = [
  {
    value: UserOptionsEnum.changePassword,
    label: 'Change Password'
  },
  // @Note - QA-1996
  // {
  //   value: UserOptionsEnum.accounts,
  //   label: 'Accounts'
  // },
  {
    value: UserOptionsEnum.logOut,
    label: 'Log Out'
  }
];
